<template>
  <div class="guidefile">
    <div class="g-top">
      <div class="g-top-l">
        <el-input v-model="params.nameLike" placeholder="名称" style="width: 100px;" size="small"></el-input>
        <el-input v-model="params.professionDutyLike" placeholder="职称" style="width: 100px;" size="small"></el-input>
        <el-input v-model="params.unitNameLike" placeholder="工作单位" style="width: 100px;" size="small"></el-input>
        <el-input v-model="params.professionalFieldLike" placeholder="技术领域特长" style="width: 100px;" size="small"></el-input>
        <el-button size="small" @click="searchArr">搜索</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="g-box">
      <tabList :arrList="arrList"></tabList>
      <div style="text-align: right;margin-top: 10px;">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page+1" :page-sizes="[10, 25, 50]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import expert from "@/data/basic/manage/expert.js";
import tabList from "@/view/manage/expert/experList.vue";
import moment from "moment";
export default {
    data() {
        return {
            params: {
                keyword: "",
                page: 0,
                size: 10,
                // 模糊查询技术领域特长
                professionalFieldLike: "",
                // 模糊名字
                nameLike: "",
                // 模糊单位
                unitNameLike: "",
                // 模糊查询职称
                professionDutyLike: "",
                // 模糊查询专家类别
                expertTypeLike: ""
            },
            total: 0,
            // 数据列表
            arrList: []
        };
    },
    components: {
        tabList
    },
    created() {
        this.expertList(this.params);
    },
    methods: {
        // 重置
        reset() {
            this.params.professionalFieldLike = "";
            this.params.nameLike = "";
            this.params.unitNameLike = "";
            this.params.professionDutyLike = "";
            this.params.expertTypeLike = "";
            this.expertList({
                page: 0,
                size: 10
            });
        },
        // 条件查询
        searchArr() {
            this.expertList(this.params);
        },
        // 页数
        handleSizeChange(val) {
            this.params.size = val;
            this.params.page = 0;
            this.expertList(this.params);
        },
        // 上一页/下一页
        handleCurrentChange(val) {
            this.params.page = val - 1;
            this.expertList(this.params);
        },
        // 专家库列表
        async expertList(params) {
            try {
                let arr = await expert.export_list(params);
                if (arr.content) {
                    this.arrList = arr.content;
                    this.total = arr.totalElements;
                }
            } catch (error) {
                this.$message.error(error.msg);
            }
        },
    },
    computed:{
    },
};
</script>
<style lang="stylus" scoped>
.g-top {
  position: resolve;
  width: 100%;
  height: 40px;
  margin-top: 5px;
  border-bottom: 1px solid #eee;

  .g-top-l {
    float: left;
  }

  .gf-btn {
    float: right;
  }
}

.iconfont {
  font-size: 12px;
}

.uploadDemo {
  float: left;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// expertControllerList.vue?6dbc68f5